import { useMutation } from "@tanstack/react-query";

import { publicApi } from "@/api/axios";

export const useSendOtp = () => {
  return useMutation({
    mutationFn: sendOtp,
  });
};

const sendOtp = async ({ email }: { email: string }) => {
  await publicApi.post("profilings/otp/send", {
    email,
  });
};
